import React from 'react';
import Homepage_Data from '../../../utils/HomepageData';

export default function AboutCard() {
  const { aboutSection } = Homepage_Data;

  return (
    <div className="mt-8 sm:mt-12 lg:mt-16 px-5 md:px-0">
      <div className="flex flex-col sm:flex-row sm:flex-wrap sm:justify-around">
        {aboutSection.map((item) => (
          <div
            key={item.id}
            className="flex items-center justify-center sm:flex-col sm:text-center sm:shadow-none mx-4 sm:mx-0 gap-2 sm:gap-4 mb-4 sm:mb-0 lg:w-[30%] lg:max-w-[385px] lg:gap-5 lg:py-6 lg:bg-white lg:rounded-lg lg:hover:shadow-lg transition-shadow duration-300"
          >
            <img
              className="w-12 sm:w-16 lg:w-20 lg:h-20 lg:object-contain"
              src={item.img}
              alt={item.text}
            />
            <div>
              <p className="text-xs sm:text-sm md:text-base lg:text-[20px] xl:text-[20px] lg:leading-relaxed lg:font-medium lg:text-gray-700 lg:px-[17px]">
                {item.text}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}